import styled from '@emotion/styled';
import { Radio } from 'antd';

export const RadioGroup = styled(Radio.Group)`
  && {
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      width: 60%;
      margin: 0 auto;
    }

    .ant-radio-wrapper {
      margin: unset;

      .ant-radio.ant-wave-target {
        display: none;
      }

      .ant-radio-label {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 6rem;
        width: 100%;
        font-size: 1.5rem;
        border: 1px solid #0e2a27;
        border-radius: 6rem;
        transition: all 0.3s ease-in-out;

        @media (max-width: 768px) {
          height: 4rem;
          font-size: 1.5rem;
        }

        @media (max-width: 480px) {
          height: 3.5rem;
          font-size: 1.25rem;
        }
      }

      &.ant-radio-wrapper-checked {
        .ant-radio-label {
          font-size: 1.75rem;
          border: 1px solid #9db98b;
          background-color: #9db98b;

          @media (max-width: 768px) {
            font-size: 1.5rem;
          }

          @media (max-width: 480px) {
            font-size: 1.25rem;
          }
        }
      }
    }
  }
`;
